<div class="row"><div class="col-sm-12">&nbsp;</div></div>
@if (error) {
  <div class="row">
    <div class="col-sm-12 red_alert" style="clear: both">
      @switch (error.error_type) {
        @case ('GroupNotFoundError') {
          <h3>Die ausgewählte Materialgruppe konnte nicht gefunden werden</h3>
        }
        @case ('ArticleError') {
          @switch (getArticleError().error_type) {
            @case ('ArticleFieldValidationError') {
              <h3>Ein Feld im Artikel ist fehlerhaft</h3>
            }
            @case ('ArticleNotFoundError') {
              <h3>Original Artikel konnte nicht gefunden werden</h3>
            }
            @case ('ArticleExistsError') {
              <h3>Es existiert bereits ein Artikel mit diesem Artikelnamen</h3>
              <a uiSref="a.material.article.update" [uiParams]="{article: getExistingArticle().id}">
                {{getExistingArticle().article_id}} {{getExistingArticle().name}}
              </a>
            }
          }
        }
        @case ('VariationsError') {
          <h3>{{ getVariationErrors().length > 1 ? 'Mehrere Variationen sind' : 'Eine Variation ist' }} fehlerhaft:</h3>
          @for (variationError of getVariationErrors(); track variationError) {
            <div>
              @switch (variationError.error_type) {
                @case ('VariationNotFoundError') {
                  Die bereits vorhandene Variation in Zeile {{variationError.index+1}} konnte nicht gefunden werden.
                }
                @case ('VariationExistsError') {
                  Die Variation in Zeile {{variationError.index+1}} existiert bereits.
                }
                @case ('VariationUnitError') {
                  Die Variation in Zeile {{variationError.index+1}} Hat eine fehlerhafte Einheit.
                }
                @case ('VariationDuplicatesError') {
                  Die Variation in Zeile {{variationError.index + 1}}
                  {{variationError.data ? 'existiert bereits in Zeile ' + (variationError.data + 1) : 'existiert mehrfach'}}.
                }
                @case ('VariationPriceParseError') {
                  Das Feld "Preis" in Zeile {{variationError.index+1}} ist nicht korrekt Formatiert.
                  Nur Zahlen, Punkte und Kommas sind erlaubt.
                }
                @case ('VariationFieldsError') {
                  Die Variationsfelder in Zeile {{variationError.index+1}} sind nicht korrekt ausgefüllt.
                }
              }
            </div>
          }
        }
        @default {
          <h3>Unbekannter Fehler beim &Uuml;bertragen des Formulars</h3>
        }
      }
    </div>
  </div>
}
